import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { matchPath } from 'react-router-dom';
import { Row, Col } from "react-bootstrap";
import { CloseButton, Loading } from '../replay/utils';
import { updateWorkWindow } from '../../../actions/map';
import { analyzeRecentSummary } from '../../../actions/analyze';
import WorkWindowContext from './WorkWindowContext';
import TimeRange from './TimeRange';
import RangeSelection from '../replay/RangeSelection';
import {
    DISPLAY_DATE_FORMAT2, DISPLAY_TIME_FORMAT,
    DISPLAY_DATETIME_FORMAT2, API_DATETIME_FORMAT
} from '../../../constants';
import { STREAM_FETCHING, STREAM_FETCHED } from './WorkWindow';
import "../../../../assets/scss/work-window.scss";

class WorkWindowBox extends Component {
    static contextType = WorkWindowContext;

    constructor() {
        super();

        this.timezone = null;
        this.workWindow = null;
        this.state = {
            refresh: 0,
            isFetching: false,
            range: null,
            dateRange: {
                start: null,
                end: null
            },
            time: {
                start: null,
                end: null
            },
            domain: []
        };

        this.getStream = this.getStream.bind(this);
        this.handleSelectDate = this.handleSelectDate.bind(this);
    }

    componentDidMount() {
        this.workWindow = this.context.workWindow;
        this.workWindow.addListener(STREAM_FETCHING, null, () => {
            this.setState({ isFetching: true });
        });

        this.workWindow.addListener(STREAM_FETCHED, null, () => {
            this.workWindow.draw();
            if (this.props.isAutoZoom) this.workWindow.setBounds();
            this.setState({ isFetching: false });
        });

        this.setState({
            range: this.props.workWindow.range,
            time: this.props.workWindow.time
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const previous = prevProps.egList.map(e => e.egId).sort().join();
        const current = this.props.egList.map(e => e.egId).sort().join();
        const isChangedEG = this.props.workWindow.enable ? (previous !== current) : false;
        if (!isChangedEG && prevState.refresh === this.state.refresh) return;

        this.getStream();
    }

    getStream = () => {
        const egList = this.props.egList;
        if (egList.length === 0) return this.workWindow.clear();

        const selectedEgIds = egList.map(e => e.egId);
        const { farmId } = this.getMatch().params;
        this.timezone = this.props.timezoneIdentifier;
        const { startDate, endDate } = this.getDateRange();

        this.workWindow
            .clear()
            .request({
                farmId, timezone: this.timezone,
                egList: this.props.allEgList, selectedEgIds,
                startDate: startDate.format(API_DATETIME_FORMAT),
                endDate: endDate.format(API_DATETIME_FORMAT)
            })
            .stream();
    }

    getDateRange = () => {
        const date = this.state.dateRange.start.clone().startOf("day");
        const min = this.state.time.start ? this.state.time.start : 0;
        const max = this.state.time.end ? this.state.time.end : (24 * 60);
        const startDate = date.clone().add(min, "minutes");
        const endDate = date.clone().add(max, "minutes");
        return { startDate, endDate };
    }

    getMatch() {
        return matchPath(window.location.pathname, {
            path: `/home/farm/:farmId/map`,
            exact: false,
            strict: false
        });
    }

    handleSelectDate = (range, dateRange, isInitial) => {
        if (!(dateRange && dateRange.start && dateRange.end)) return;
        const { min, max } = this.getSliderRange(range, dateRange);
        this.setState({
            range, dateRange,
            domain: [min, max],
            ...isInitial ? { time: this.props.workWindow.time } : { time: { start: min, end: max } },
            refresh: (dateRange.start === this.state.dateRange.start && dateRange.end === this.state.dateRange.end) ?
                this.state.refresh : this.state.refresh + 1
        });
    }

    handleUpdateTime = ({ min, max }) => {
        this.setState({ time: { start: min, end: max } });
    }

    getSliderRange(range, dateRange) {
        let max = 1;
        if (range === 1) max = dateRange && dateRange.end ?
            (dateRange.end.hours() + (dateRange.end.hours() < 24 ? 1 : 0)) * 60 : 1;
        else if (dateRange && dateRange.start && dateRange.end) {
            max = dateRange.end.clone().diff(dateRange.start, "minutes");
        }
        else max = (24 * 60);
        return { min: 0, max: max > 0 ? max : 1 };
    }

    getDisplayDate() {
        const { time, dateRange } = this.state;

        let displayDate = "";

        if (time.start !== null && time.end !== null) {
            const { startDate, endDate } = this.getDateRange();
            if (endDate.diff(startDate, "hours") < 24)
                displayDate = `${startDate.format(DISPLAY_DATETIME_FORMAT2)} to ${endDate.format(DISPLAY_TIME_FORMAT)}`;
            else
                displayDate = `${startDate.format(DISPLAY_DATETIME_FORMAT2)} to ${endDate.format(DISPLAY_DATETIME_FORMAT2)}`;
        } else if (dateRange.start && dateRange.end) {
            if (dateRange.end.diff(dateRange.start, "hours") < 24)
                displayDate = `${dateRange.start.format(DISPLAY_DATE_FORMAT2)}`;
            else
                displayDate = `${dateRange.start.format(DISPLAY_DATE_FORMAT2)} to ${dateRange.end.format(DISPLAY_DATE_FORMAT2)}`;
        }

        return { displayDate };
    }

    componentWillUnmount() {
        this.props.actions.updateWorkWindow({
            range: this.state.range,
            dateRange: this.state.dateRange
        });
    }

    render() {
        const { isFetching, time, range, dateRange, domain } = this.state;
        const { workWindow, timezoneIdentifier } = this.props;
        const timezone = this.timezone ? this.timezone : timezoneIdentifier;
        const { displayDate } = this.getDisplayDate();

        return (
            <div className="wrapper">
                {isFetching && <Loading />}
                <Row className="content map-workw-modal">
                    <Col md={12} className="px-0">
                        <Row className="mx-0  map-workw-header">
                            <Col md={6} className='px-0'>
                                {range && timezone &&
                                    <RangeSelection
                                        timezone={timezone}
                                        defaultRange={workWindow.range}
                                        onChange={this.handleSelectDate}
                                        calendar={{
                                            maxSelectDays: 10,
                                            defaultDate: workWindow.dateRange,
                                            enabledDate: workWindow.enabledDate
                                        }}
                                    />}
                            </Col>                            
                            <Col md={6} className="px-0">
                                <div className="d-flex justify-content-center justify-content-xl-end float-xl-right">
                                    {displayDate && <span className="date-text">
                                        <b>{displayDate}</b>
                                    </span>}
                                    <CloseButton onClick={this.context.onClose} />
                                </div>
                            </Col>
                        </Row>
                        {domain.length > 0 &&
                            <TimeRange
                                onUpdate={this.handleUpdateTime}
                                values={[time.start, time.end]}
                                dateRange={dateRange}
                                domain={domain}
                                fetchStream={this.getStream}>
                            </TimeRange>}
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    timezoneIdentifier: state.farm.currentFarm.timezone_identifier,
    isAutoZoom: state.map.isAutoZoom,
    egList: state.map.filteredEgList,
    allEgList: state.map.egList,
    workWindow: state.map.workWindow
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ updateWorkWindow, analyzeRecentSummary }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkWindowBox);